/**
 * Loading Page
 *
 * Displayed while validating token or loading content.
 */
import { Spinner } from '@respectly/ui';
import { PortalLayout } from '../layouts/PortalLayout';

interface LoadingPageProps {
  message?: string;
}

export function LoadingPage({ message = 'Loading...' }: LoadingPageProps) {
  return (
    <PortalLayout showFooter={false}>
      <div className="flex flex-1 flex-col items-center justify-center p-4">
        <Spinner size="lg" />
        <p className="mt-4 text-gray-600">{message}</p>
      </div>
    </PortalLayout>
  );
}
